module.exports = __webpack_public_path__ + "static/image-malaika-pictures-eea956ac44ab66f67cd8b68313822676.jpg";